<template>
  <div class="main">
    <div class="top">
      <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717605270411135.png" />
    </div>
    <div class="card">
      <div class="card-box">
        <div class="stu-name">{{ userInfo.realname }}</div>
        <div class="stu-school">{{ userInfo.school }}</div>
        <div class="stu-grade">入学{{ userInfo.join_year }}级</div>
        <div class="stu-record">
          <router-link to="/shaonianjingxiao/record">积分记录</router-link>
        </div>
        <div class="study-score"><span class="score">{{ userInfo.learn_jifen }}</span>分</div>
        <div class="active-score"><span class="score">{{ userInfo.active_jifen }}</span>分</div>
      </div>
    </div>

    <div class="baoming">
      <div class="new">
        <a href="https://wenling.tidenews.com.cn/webForum/subject?id=227303&tenantId=22">
          <img src="https://private-wenlingd.tmuyun.com/15874737084868.png?attname=%E6%B4%BB%E5%8A%A8%E9%A1%B5%E9%9D%A220251011.png&e=2390887931&token=x42UVtCycB6T0-XLPVeFgK_MQlfk3CS9AYLOiwTV:Z4Te9TUu95jAEJ1-QSa6o9OTovM=" alt="">
        </a>
      </div>
      <div class="huodong" style="display: none;">

        <div>
          <a href="https://wenling.y-h5.iyunxh.com/module-supertopic/home/home?hide_back=1&id=616">
            <img src="https://private-wenlingd.tmuyun.com/14243697198980.png?attname=1.png&e=2365403008&token=x42UVtCycB6T0-XLPVeFgK_MQlfk3CS9AYLOiwTV:Gs5zXspzlIKpU4PKcMcvCKcQwaI=" />
          </a>
        </div>
        <div>
          <a href="https://wenling.y-h5.iyunxh.com/module-vote/home/home?hide_back=1&id=841">
            <img src="https://private-wenlingd.tmuyun.com/14243697195908.png?attname=2.png&e=2365403068&token=x42UVtCycB6T0-XLPVeFgK_MQlfk3CS9AYLOiwTV:KfZ4LMbRQOxBhhj3cotxIliwJjw=" alt="">
          </a>
        </div>
      </div>
    </div>
    <div class="bg">
      <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717627586908578.png" />
    </div>
    <div class="container">
      <div class="xuetang">
        <div class="top-line">
          <div class="title">
            <div class="title-decorate"></div>
            <div class="title-content">阿狮学堂</div>
          </div>
          <div class="more"><router-link to="videos">更多&gt;</router-link></div>
        </div>
        <div class="xuetang-video-list">
          <div class="xuetang-video" v-for="item in videos" :key="item.id">
            <a @click="classRedirect(item)">
              <div class="xuetang-video-screen">
                <img :src="item.cover" />
              </div>
              <div class="video-label"><img :src="item.hasWatched ? 'https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718710203051753.png': 'https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718710204271674.png'" /></div>
              <div class="xuetang-video-box">
                <div>
                  <div class="xuetang-video-title">{{item.title}}</div>
                  <div class="xuetang-video-content">{{ item.remark }}</div>
                </div>
                <div class="xuetang-video-play" v-if="item.type == 1">
                  <img src="https://i.tmuyun.com/webpic/W0202407/W020240719/W020240719462487967845.png" />
                </div>
              </div>
            </a>
          </div>
          
        </div>
      </div>
      <div class="fengcai">
        <div class="top-line">
          <div class="title">
            <div class="title-decorate"></div>
            <div class="title-content">少警风采</div>
          </div>
          <div class="more"><a href="https://app.tmuyun.com/webDetails/sonPage?id=10113619&tenantId=3&groupId=2124727">更多&gt;</a></div>
        </div>
        <div class="fengcai-video-list">

          <div class="fengcai-video" v-for="item in atticles" :key="item.id">
            <a :href="item.url">
              <div class="fengcai-video-cover"><img :src="item.cover" /></div>
              <div class="fengcai-video-right">
                <div class="fengcai-video-title">{{item.title}}</div>
                <div class="fengcai-video-content">{{ item.mark }}</div>
              </div>
            </a>
          </div>

        </div>
      </div>
      <div class="duihuan">
        <div class="title">
          <div class="title-decorate"></div>
          <div class="title-content">积分兑换</div>
        </div>
        <div class="message-box">
          <van-icon name="https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718508034903731.png" />
          <!-- <div class="message">每月15日9点开始线上学习平台积分兑换！仅限一天~</div> -->
          <!-- <div class="message">10月31日9点，开启少年警校体验名额报名，仅限6个，先到先得！</div> -->
           <div class="message">兑换成功后，请前往温岭市公安局宣传科办公室领取，联系电话：13958646088（陈泓妤）</div>
        </div>
        <div class="gift-box">
          <div class="gift" v-for="item in prizes" :key="item.id">
            <div class="gift-title">{{ item.prize_name }}</div>
            <img :src="item.cover" />
            <div class="gift-score"><span class="score2">{{ item.integral }}</span>积分</div>
            <div class="gift-exchange" @click="exchange(item)">立即兑换</div>
          </div>

        </div>
      </div>
    </div>
    <div class="bottom">
      <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717612782567500.png" />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
var isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)

import { getUserInfo, hasLogin, saveFirstLogin, getVideoList, getArticleList, viewArticle, getPrizeList,doDuihuan } from '@/api/snjx'
import { Dialog, Toast } from 'vant'
export default {
  data(){
    return {
      themeId: 1,
      userInfo: {},
      videos: [],
      atticles: [],
      prizes: [],
      duihuaning: false
    }
  },
  mounted() {
    let params = { theme_id: this.themeId }
    getUserInfo(params).then((res) => {
      if (res.code == 1) {
        if (res.data) {
          this.userInfo = res.data
          // 判断当天是否第一次登录
          hasLogin(params).then((re) => {
            if(re.code == 1){
              if(re.data === false){
                saveFirstLogin(params).then((r) => {
                  if(r.code == 1){
                    this.userInfo.learn_jifen = parseInt(this.userInfo.learn_jifen) + r.data
                    Toast.success(r.msg)
                  }else{
                    Toast.fail(r.msg)
                  }
                })
              }
            } else {
              Toast.fail(res.msg)
            }
          })

          // 获得文章列表
          getArticleList({theme_id: this.themeId, limit: 3}).then((re) => {
            if(re.code == 1){
              this.atticles = re.data
            }else{
              Toast.fail(re.msg)
            }
          })

          // 获得视频列表
          getVideoList({theme_id: this.themeId, limit: 2}).then((re) => {
            if(re.code == 1){
              this.videos = re.data
            }else{
              Toast.fail(re.msg)
            }
          })

          // 获取奖品列表
          getPrizeList({theme_id: this.themeId}).then((re) => {
            if(re.code == 1){
              this.prizes = re.data
            }else{
              Toast.fail(re.msg)
            }
          })  
        } else {
          Toast({
            type: 'fail',
            message: '请先注册',
            onClose: () => {
              this.$router.push({ name: 'snjx_register' })
            }
          })
        }
      } else {
        Toast.fail(res.msg);
      }
    })
  },
  methods: {
    classRedirect(item){
      if(item.type == 1){
        this.$router.push({name: 'snjx_video', params: {id: item.id}})
      }else{
        if(item.hasWatched == 1){
          window.location.href = item.url
        }else{
          const toast = Toast.loading('正在跳转')
          
          viewArticle({theme_id: this.themeId, article_id: item.id, type: item.type}).then((res) => {
            if(res.code == 1){
              item.hasWatched = 1
              Toast.clear()
              window.location.href = item.url
            }else{
              Toast.fail(res.msg)
            }
          })
        }
      }
      // :to="{name: 'snjx_video', params: {id: item.id}}"
    },
    goToSign(){
      window.location.href = 'https://wenling.y-h5.iyunxh.com/module-supertopic/home/home?hide_back=1&id=616'
    },
    exchange(item) {
      if(this.duihuaning) return;

      Dialog.confirm({
        title: '兑换',
        message: `您确定要兑换${item.prize_name}吗？`,
      }).then(() => {
        let diff = false
        // 如果是兑换课程的
        if(item.id == 6){
          const startDate = dayjs(`2024-09-26 09:00:00`);
          const endDate = dayjs(`2024-09-26 23:59:59`); 
          diff = dayjs().isBetween(startDate, endDate)
        }else if(item.id == 7){
          const startDate = dayjs(`2024-10-31 09:00:00`);
          const endDate = dayjs(`2024-10-31 23:59:59`); 
          diff = dayjs().isBetween(startDate, endDate)
        }else{
          
          
          if(dayjs().isBefore('2025-10-01')) {
            diff = true;
          } else {
            // 9-12月的15号9点开启兑换
            const openDate = ['2025-09-26', '2025-10-15', '2025-11-15', '2025-12-15', '2026-01-15', '2026-02-15', '2026-03-15', '2026-04-15']
            const openTime = "09:00:00"
            const endTime = "23:59:59"
            const nowTime = dayjs();
            
            try{  
              openDate.forEach(date => {  
                const startDate = dayjs(`${date} ${openTime}`);
                const endDate = dayjs(`${date} ${endTime}`);
                diff = nowTime.isBetween(startDate, endDate);
                if(diff){
                  throw new Error('ok')
                }
              })
            }catch(err){
              // console.log(err)
            }
          }
        }

        if (diff) {
          // 判断奖品是否还有剩余
          if(item.remaining_num > 0){
            // 判断积分是否足够
            let total_jifen = parseInt(this.userInfo.learn_jifen) + parseInt(this.userInfo.active_jifen)
            if (total_jifen >= item.integral) {
              // 可以兑换  
              this.duihuaning = true
              doDuihuan({prize_id: item.id, theme_id: this.themeId}).then((res) => {
                this.duihuaning = false
                if(res.code == 1){
                  item.remaining_num = parseInt(item.remaining_num) - 1
                  item.zhongchou_num = parseInt(item.zhongchou_num) + 1
                  // 判断学习积分是否可以覆盖所需的积分了
                  if(this.userInfo.learn_jifen >= item.integral){
                    this.userInfo.learn_jifen = parseInt(this.userInfo.learn_jifen) - parseInt(item.integral)
                  }else{
                    this.userInfo.active_jifen = this.userInfo.active_jifen - (parseInt(item.integral) - parseInt(this.userInfo.learn_jifen) )
                    this.userInfo.learn_jifen = 0;
                  }
                  Toast.success(res.msg)
                }else{
                  Toast.fail(res.msg)
                }
              })
            }else{
              Toast.fail('积分不足')
            }
          }else{
            Toast.fail('该奖品本轮已兑换完毕，请下次再来。')
          }
        } else {
          Toast.fail('积分兑换暂未开启，敬请期待')
        }
        }
      );
        
    },
  }
}
</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .main {
    position: relative;
    height: 2450px;
    background:rgb(236,248,254);
  }

  .top {
    position: absolute;
    z-index: 1;
    top: 0;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .card {
    position: absolute;
    z-index: 2;
    top: 235px;
    width: 100%;

    .card-box {
      position: relative;
      margin: 0 auto;
      width: 375px;
      height: 250px;
      background: url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718570131167670.png') no-repeat;
      background-size: 100%;

      .stu-name {
        position: absolute;
        top: 30px;
        left: 40px;
        font-size: 23px;
        font-weight: bold;
        color: #000000;
      }

      .stu-school{
        position: absolute;
        top: 76px;
        left: 40px;
        padding: 0 0 0 30px;
        width:162px;
        height:22px;
        line-height: 22px;
        background:url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718710396779364.png');
        background-size: 100%;
        font-size:12px;
        color:#000000;
      }

      .stu-grade{
        position: absolute;
        top: 106px;
        left: 40px;
        padding: 0 0 0 30px;
        width:162px;
        height:22px;
        line-height:22px;
        background:url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718710396538542.png');
        background-size: 100%;
        font-size:12px;
        color:#000000;
      }

      .stu-record{
        position:absolute;
        top:110px;
        right:30px;
        width:100px;
        height: 30px;
        line-height: 30px;
        border-radius: 16px;
        background:#5492EC;
        text-align:center;
        font-size:14px;
        font-weight: bold;
        a{
          color:#FFFFFF;
        }
      }

      .study-score{
        position: absolute;
        left: 76px;
        bottom: 76px;
      }
      .active-score{
        position: absolute;
        right: 76px;
        bottom: 76px;
      }
      .score{
        font-size:25px;
        font-weight: bold;
      }
    }
  }

  .baoming {
    position: absolute;
    z-index: 2;
    top: 480px;
    width: 100%;
    text-align: center;
    .new {
      position: relative;
      width: 360px;
      margin: auto;
      img {
        width: 100%;
      }
    }
    .huodong{

      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 10px;
      div {
        flex: 0 0 45%;
      }
      img {
        width: 100%;
      }
    }
  }

  .bg {
    position: absolute;
    z-index: 1;
    top: 730px;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .container {
    position: absolute;
    z-index: 2;
    top: 610px;
    width: 100%;
  }

  .xuetang,
  .fengcai,
  .duihuan {
    width: 350px;
    margin: 30px auto 0 auto;
  }

  .top-line {
    display: flex;
    justify-content: space-between;
  }

  .title {
    display: flex;

    .title-decorate {
      width: 6px;
      background: #136AE8;
      border-radius: 5px;
    }

    .title-content {
      margin: 0 0 0 8px;
      font-size: 20px;
      color: #000000;
      font-weight: bold;
    }
  }

  .more {
    a {
      color: #818181;
    }
    font-size: 15px;
  }

  .xuetang-video-list{
    margin: 20px 0;
    .xuetang-video{
      width: 350px;
      height: 248px;
      margin: 10px 0;
      background:url('https://i.tmuyun.com/webpic/W0202407/W020240719/W020240719400638396180.png');
      background-size: 100%;

      .xuetang-video-screen{
        position: relative;
        top: 30px;
        left: 20px;
        width: 310px;
        height: 165px;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }
      }

      .video-label{
        position: relative;
        left: 270px;
        top: -110px;
        width: 80px;
        img{width:100%;}
      }

      .xuetang-video-box{
        // position: relative;
        // top: 8px;
        // left: 20px;
        // width: 310px;
        width: 88%;
        margin: auto;
        margin-top: 5px;
        display:flex;
        justify-content: space-between;
        .xuetang-video-title{
          color: #000;
          font-size: 14px;
        }
        .xuetang-video-content{
          margin-top: 3px;
          font-size: 12px;
          color:#959595;
        }
      }
      .xuetang-video-play{
        width: 30px;

        img{width:100%;}
      }
    }
  }

  .fengcai-video-list{
    .fengcai-video{
      margin: 10px 0;
      padding: 10px;
      border-radius: 10px;
      background:#fff;
      box-shadow: 0.67px 0.74px 8px #A3C1EB4D;
      a{
        display:flex;
        justify-content:space-between;
        .fengcai-video-cover{
          width:165px;
          height:95px;
          background:#136AE8;
          border-radius: 10px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .fengcai-video-right{
        width: 145px;
        .fengcai-video-title{
          color: #000;
          font-size: 16px;
        }
        .fengcai-video-content{
          margin: 20px 0 0 0;
          font-size:16px;
          color:#959595;
        }
      }
    }
  }

  .message-box {
    margin: 16px 0;
    padding: 10px 16px;
    background: rgba(55, 136, 235, 0.33);
    border-radius: 20px;
    display: flex;
  }

  .message {
    border-left: 1px solid #FFFFFF;
    font-size: 14px;
    color: #000000;
    margin: 0 0 0 8px;
    padding: 0 0 0 8px;
  }

  .gift-box {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
  }

  .gift {
    margin: 6px 0;
    width: 165px;
    height: 190px;
    background: url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718621423124431.png');
    background-size: 100%;

    .gift-title {
      margin-top: 8px;
      width: 100%;
      text-align:center;
      font-size:11px;
      color:#FFFFFF;
    }
    img {
      margin-top: -22px;
      width: 100%;
    }
    .gift-score{
      margin: -46px 0 0 24px;
      font-size: 12px;
    }
    .score2{
      font-size:20px;
      font-weight: bold;
    }
    .gift-exchange{
      margin: -18px 0 0 98px;
      bottom:26px;
      font-size: 9px;
      color:#fff;
    }
  }

  .bottom {
    position: absolute;
    z-index: 1;
    bottom: 0;
    width: 100%;

    img {
      width: 100%;
    }
  }
</style>